module.exports = __webpack_public_path__ + "static/img/055_TO8_1598.2d914f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/055_TO8_1598.jpg
// module id = cvpy
// module chunks = 0